
export default {
  name: 'FaqList',
  components: {},
  mixins: [],
  props: {
    faqData: {
      type: Array,
    },
  },
  asyncData: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
}
